"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
var _PointsOrDealLabel = require("./PointsOrDealLabel");
Object.keys(_PointsOrDealLabel).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _PointsOrDealLabel[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _PointsOrDealLabel[key];
    }
  });
});
//# sourceMappingURL=index.js.map